const inbox = {
  title: '收件箱',
  subtitle: '集中查看所有已绑定邮箱的候选人邮件与回复',
  sync: '同步邮件',
  refresh: '刷新列表',
  threadCount: '已加载 {shown}/{total}',
  loadMore: '加载更多',
  connect: '绑定收件箱',
  folders: '文件夹',
  allMailboxes: '全部邮箱',
  mailboxes: '邮箱账户',
  unread: '仅看未读',
  search: '搜索主题或正文',
  clearSearch: '清除搜索',
  retry: '重试',
  loadFailed: '收件箱加载失败',
  statusUpdateFailed: '已读状态更新失败',
  emptyTitle: '暂无邮件',
  emptyHint: '同步完成后，新邮件会出现在这里',
  connectHint: '先绑定一个邮箱开始收取邮件',
  selectConversation: '选择一封邮件查看对话',
  noSubject: '无主题',
  campaign: '冷邮件活动',
  reply: '回复',
  replyPlaceholder: '输入回复内容…',
  replyFrom: '通过 {email} 回复',
  sendReply: '发送回复',
  markRead: '标记已读',
  markUnread: '标记未读',
  markReadSuccess: '已标记为已读',
  markUnreadSuccess: '已标记为未读',
  markAllRead: '全部标为已读',
  markAllReadSuccess: '已全部标记为已读',
  connectTitle: '绑定收件箱',
  connectDescription: '选择已有发件邮箱并开启收件同步',
  senderAccount: '邮箱账户',
  selectAccount: '选择邮箱',
  provider: '收件方式',
  gmailProviderHint: '只有通过 Google OAuth 授权的邮箱才能使用 Gmail API。',
  imapHost: 'IMAP 服务器',
  imapPort: 'IMAP 端口',
  useSsl: '使用 SSL/TLS',
  gmailReauthorizeHint:
    '首次启用 Gmail 收件需要重新授权读取邮件权限。若同步提示权限不足，请前往邮箱配置重新授权。',
  syncing: '同步中…',
  syncFailureBadge: '同步失败',
  syncFailureConnection: '同步失败：无法连接邮箱服务',
  syncFailureAuth: '同步失败：请检查登录凭据或重新授权',
  syncFailureUnknown: '同步失败，请检查邮箱设置',
  syncFailureRetrying: '正在重试…',
  syncFailureRetry: '重试同步',
  syncFailureSettings: '邮箱设置',
  syncComplete: '邮件同步完成',
  syncFailed: '{count} 个邮箱同步失败，请检查邮箱配置后重试',
  connectFailed: '邮箱绑定失败，请检查邮箱配置后重试',
  deleteAccount: '解除绑定',
  deleteAccountTitle: '解除收件箱绑定',
  deleteAccountDescription: '确定要解除邮箱 {email} 的收件箱绑定吗？解除后该邮箱将不再同步新邮件。',
  deleteAccountSuccess: '已解除收件箱绑定',
  deleteAccountFailed: '解除绑定失败，请稍后重试',
  replySent: '回复已发送',
  replyFailed: '回复发送失败，请检查邮箱发信配置后重试',
  sendShortcutHint: '发送 (Ctrl + Enter)',
  editor: {
    bold: '加粗 (Ctrl+B)',
    italic: '斜体 (Ctrl+I)',
    underline: '下划线 (Ctrl+U)',
    orderedList: '有序列表',
    bulletList: '无序列表',
    link: '插入链接',
    clean: '清除格式',
  },
  tabAll: '全部',
  tabUnread: '未读',
  tabWait: '待回复',
  newMail: '写邮件',
  hideInfo: '收起侧边栏',
  showInfo: '展开侧边栏',
  delivered: '已送达',
  aiSuggestReply: '建议回复',
  aiSuggestSchedule: '沟通面试',
  from: '发件',
  to: '收件',
  viewCandidate: '查看人才',
  candidate: '候选人',
  candidateLocation: '地区',
  candidateExperience: '工作年限',
  candidateEducation: '最高学历',
  experienceYears: '{years} 年',
  timeline: '动态时间线',
  latestMessage: '最新往来',
  firstMessage: '首次沟通',
  notes: '团队备注',
  notesPlaceholder: '记录该候选人的关键信息（仅团队成员可见）…',
  folder: { all: '全部邮件', inbox: '收件箱', sent: '已发送', archive: '归档', unarchive: '取消归档', drafts: '草稿箱', junk: '垃圾邮件', trash: '已删除' },
  status: { pending: '等待首次同步', syncing: '正在同步', ready: '同步正常', error: '同步异常' },
  addToJob: '加入岗位',
  addToJobPending: '已通知后端排期，暂不支持加入岗位',
  viewCandidateDetails: '查看人才详情',
  linkedJob: '关联岗位',
  noLinkedJob: '未关联具体岗位',
  talentPoolTags: '人才库标签',
  noTags: '暂无标签',
  currentJobStatus: '当前岗位的状态',
  recentActivity: '最近动态',
  reauthorize: '重新授权',
  reauthorizeRequired: '需重新授权',
  candidateResumeFailed: '候选人简历加载失败',
  archiveSuccess: '归档成功',
  archiveFailed: '归档失败',
  unarchiveSuccess: '取消归档成功',
  unarchiveFailed: '取消归档失败',
  stageUpdateSuccess: '修改阶段成功',
  stageUpdateFailed: '修改阶段失败',
  tabWaitHint: '后端暂不支持筛选待回复，暂时显示全部',
  reauthorizeSuccess: '重新授权成功',
  reauthorizeFailed: '重新授权失败',
  reauthorizeSaveFailed: '重新授权保存失败',
  connectFirst: '请先绑定邮箱账号',
  recipientAndSubjectRequired: '收件人和主题必填',
  sendSuccess: '发送成功',
  sendFailed: '发送失败',
  moreActionsPending: '暂未支持更多操作（等待后端 API）',
  downloadAttachmentFailed: '附件下载失败',
  emailTemplates: '邮件模板',
  scheduleSend: '定时发送',
  scheduleSendPending: '暂不支持定时发送',
  insertTemplateTitle: '插入邮件模板',
  selectTemplatePlaceholder: '请选择邮件模板',
  insert: '插入',
  getTemplatesFailed: '获取邮件模板失败',
  linkPlaceholder: '输入或粘贴链接 (如 https://...)',
  subject: '主题',
  subjectPlaceholder: '邮件主题',
  toPlaceholder: '输入邮箱地址，多个用逗号分隔',
}

export default inbox
